import { AfterViewInit, Component, ElementRef, ViewChild, NgZone } from '@angular/core';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { URL_DOCS } from 'src/app/config/config';
declare var $: any;

@Component({
  selector: 'app-admin-b2b-agreement-type',
  templateUrl: './admin-b2b-agreement-type.component.html',
  styleUrls: ['./admin-b2b-agreement-type.component.css']
})
export class AdminB2bAgreementTypeComponent implements AfterViewInit  {

  URL_DOCS = URL_DOCS;
  public b2bAgreementTypeList: any = [];
  public b2bAgreementTypeSelected: any = [];
  isEdit = false;
  isLoading = false;
  modalActivo: 'crear' | 'editar' | null = null;
  
  selectedImageFile: File | null = null;
  imagePreview: string | ArrayBuffer | null = null;
  imageError: string | null = null;

  numeros: number[] = Array.from({ length: 21 }, (_, i) => i);
  numeroSeleccionado: number | null = null;

  errores: { [key: string]: boolean } = {};

  @ViewChild('visualizarB2BType') visualizarB2BType: ElementRef;

  constructor(
    public mantenedorService: MantenedorService,
    private ngZone: NgZone
  ) {}

  ngAfterViewInit(): void {
    this.getB2BAgreementType();
    $(this.visualizarB2BType.nativeElement).on('hidden.bs.modal', () => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.resetModalState();
        });
      });
    });
  }

  resetModalState() {
    this.b2bAgreementTypeSelected = {};
    if (this.isEdit) {
      this.isEdit = false;
      this.selectedImageFile = null;
      this.imagePreview = null;
    }
  }

  getB2BAgreementType() {
    this.isLoading = true;
    this.mantenedorService.getB2BAgreementType().then((res: any) => {
      this.b2bAgreementTypeList = res.data;
    })
    .catch((error: any) => {console.log(error)})
    .finally(() => { this.isLoading = false; });
  }

  clickB2BType(b2bAgreementType) {
    this.b2bAgreementTypeSelected = b2bAgreementType;
  }

  editB2BType() {
    this.isEdit = !this.isEdit;
    this.modalActivo = 'editar';
  }

  cancelEditB2BType() {
    //this.b2bAgreementTypeSelected = {};
    this.isEdit = false;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

    if (file) {
      if (!allowedTypes.includes(file.type)) {
        this.imageError = 'Formato no válido. Solo se permiten JPG, PNG o WEBP.';
        this.selectedImageFile = null;
        this.imagePreview = null;
        return;
      }

      const maxSizeMB = 2;
      if (file.size > maxSizeMB * 1024 * 1024) {
        this.imageError = 'La imagen no debe superar los 2 MB.';
        this.selectedImageFile = null;
        this.imagePreview = null;
        return;
      }

      this.selectedImageFile = file;
      this.imageError = null;

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  clearSelectedImage(): void {
    this.selectedImageFile = null;
    this.imagePreview = null;
    this.imageError = null;
  }

  private validarCamposObligatorios(campos: string[], datos: any): boolean {
    this.errores = {};
    let valido = true;

    for (const campo of campos) {
      const valor = datos[campo];

      if (!valor || valor.toString().trim() === '') {
        this.errores[campo] = true;
        valido = false;
      }
    }

    if (!valido) {
      setTimeout(() => {
        this.errores = {};
      }, 5000);
    }

    return valido;
  }

  updateB2BType() {

    // console.log('B2B a modificar:', this.b2bAgreementTypeSelected);

    const camposRequeridos = ['con_info_title', 'con_info_description'];
    if (!this.validarCamposObligatorios(camposRequeridos, this.b2bAgreementTypeSelected)) {
      return;
    }
    this.isLoading = true;



    // if (this.selectedImageFile) {
      // const formData = new FormData();
      // formData.append('file', this.selectedImageFile);
      // formData.append('agre_typ_id', this.b2bAgreementTypeSelected.agre_typ_id);

      // //this.agreementTypeService.uploadImage(formData).then((res: any) => {
      // //  console.log('Imagen subida:', res);
      // //  this.selectedImageFile = null;
      // //  this.finalizarEdicion(); // luego editar el resto de los datos
      // //}).catch((err) => {
      // //  console.error('Error subiendo imagen:', err);
      // //});
    // } else {
      // console.log('No se ha seleccionado ninguna imagen');
      // //this.finalizarEdicion();
    // }
    
    //this.mantenedorService.updateB2BAgreementType(this.b2bAgreementTypeSelected, this.selectedImageFile).then((res: any) => {
    //  this.getB2BAgreementType();
    //})
    //.catch((error: any) => {console.log(error)})
    //.finally(() => { this.isLoading = false; });
  }

}
